if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
			// Optional
			loadProductFirst: false,
			numberFilterTree: 2,
			showPlaceholderProductList: true
		},
		selector: {
			breadcrumb: '.breadcrumb',
			otpTopCartCount: '.cart-count'
		}
	};
}

(function() {
	BoostPFS.inject(this);

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;

		
		/*** Prepare data ***/
        var images = data.images_info;
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale

        /* Start-Boost-231939 */
        var variantComparePrice = '';
        var variantPrice = '';
        if(data.price_min){
            var onSaleVariant = data.compare_at_price_min > data.price_min;
            if(onSaleVariant){
              variantComparePrice = parseFloat(data.compare_at_price_min);
              variantPrice = parseFloat(data.price_min);
              onSale = true;
            }
        }else{
          var onSaleVariant = data.variants.filter(function(e) {
              return parseFloat(e.compare_at_price) > parseFloat(e.price);
          })
          if (typeof onSaleVariant[0] !== 'undefined') {
              variantComparePrice = parseFloat(onSaleVariant[0].compare_at_price);
              variantPrice = parseFloat(onSaleVariant[0].price);
              onSale = true;
          }
        }
        /* End-Boost-231939 */
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add a specific class for grid item
		var gridItemWidthClass = '';
		var imageSize = '600x600';
		var width = '', height = '';
		switch(boostPFSConfig.custom.products_per_row) {
			case 2:
				gridItemWidthClass = 'medium--one-half large--one-half';
				imageSize = '540x600';
				width = 540;
				height = 600;
				break;
			case 3:
				gridItemWidthClass = 'small--one-half medium--one-third large--one-third';
				imageSize = '345x550';
				width = 345;
				height = 550;
				break;
			case 4:
				gridItemWidthClass = 'small--one-half medium--one-quarter large--one-quarter';
				imageSize = '250x';
				width = 250;
				height = 225;
				break;
			case 5:
				gridItemWidthClass = 'small--one-half medium--one-fifth large--one-fifth';
				imageSize = '195x';
				width = 195;
				height = 125;
				break;
		}
		itemHtml = itemHtml.replace(/{{gridItemWidthClass}}/g, gridItemWidthClass);

		// Add soldOut class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		// Add onSale class
		var onSaleClass = onSale ? boostPFSTemplate.onSaleClass : '';
		itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);

        var count_tag = false;
        var inventoryAvailable = false;
        var inventoryContinue = false;

        $(data.variants).each(function( index, element ) {
          if(element.inventory_quantity > 0){
            inventoryAvailable = true;
          }
          if(element.inventory_policy == 'continue' && element.inventory_quantity <= 0){
            inventoryContinue = true;
          }
        });

		var stockGroup = '';
		if(data.metafields && data.metafields.length) {
			console.log(data);
			data.metafields.forEach((metafield) => {
				if(metafield.key == 'external_stock_group' && metafield.value && metafield.value !== '') {
					stockGroup = metafield.value;
				}
			});
		}	

		var inStockMsg = 'AVAILABLE TO ORDER';
		var isDirectStock = false;

		if(stockGroup == 'Ballybofey') {
			inStockMsg = 'IN STOCK';
			isDirectStock = true;
		} else if(stockGroup == 'GIE') {
			inStockMsg = 'IN STOCK';
			isDirectStock = true;
		} else if(stockGroup == 'VIDA') {
			inStockMsg = 'IN STOCK';
			isDirectStock = true;
		}
		
        if(inventoryAvailable == false && inventoryContinue == true){
          count_tag = true;
          var pre_order = '<div class="product-qty"><div class="qty-label flex"><span>AVAILABLE TO ORDER</span></div>';
          itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, pre_order);
        } else {
          count_tag = true;
          var pre_order = '<div class="product-qty"><div class="qty-label flex"><span>'+inStockMsg+'</span></div>';
          itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, pre_order);
        }
      
        if(count_tag == false ){
          // Add soldOut label and InStock		
          if(data.available == false){
            var itemSoldOutLabelHtml = soldOut ? boostPFSTemplate.soldOutLabelHtml : '';
            itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, '<div class="product-qty"><div class="qty-label flex"><span>OUT Of STOCK</span></div>');
          } else {

            $(data.variants).each(function( index, element ) {
              if( (element.inventory_quantity) > 0 && (element.inventory_quantity) <= 5 && isDirectStock ){              
                itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, '<div class="product-qty"><div class="qty-label flex dark-label"><span>ONLY '+ element.inventory_quantity + ' LEFT IN STOCK</span></div>');
              } else {
                itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, '<div class="product-qty"><div class="qty-label flex"><span>'+ inStockMsg +'</span></div>');
              }                            
            });

			if(data.inventory_quantity > 0) {
				itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, '<div class="product-qty"><div class="qty-label flex"><span>'+ inStockMsg +'</span></div>');
			} else {
				itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, '<div class="product-qty"><div class="qty-label flex"><span>AVAILABLE TO ORDER</span></div>');
			}
            
          }
        }
      
		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], imageSize) : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Price
        var itemPriceHtml = '<span class="product-price medium--left 456">';
		if (onSale) {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price  + '</span>';
		} else {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
		}
		// itemPriceHtml += buildPriceHtml(data.price_min);
        /* Start-Boost-231939 */
        if (typeof onSaleVariant[0] !== 'undefined') {
            itemPriceHtml += buildPriceHtml(variantPrice);
        } else {
            itemPriceHtml += buildPriceHtml(data.price_min);
        }
        /* End-Boost-231939 */
		if (onSale && boostPFSConfig.custom.show_compare_at_price) {            
			itemPriceHtml += ' <small class="compare-price"><s><span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
            /* Start-Boost-231939 */
            if (typeof onSaleVariant[0] !== 'undefined') {
                itemPriceHtml += buildPriceHtml(variantComparePrice);
            } else {
                itemPriceHtml += buildPriceHtml(data.compare_at_price_min);
            }
            /* End-Boost-231939 */
			// itemPriceHtml += buildPriceHtml(data.compare_at_price_min);
			itemPriceHtml += '</s></small>';
		}

      
		itemPriceHtml += '</span>';
		if (onSale && boostPFSConfig.custom.product_show_saved_amount) {
            var class1 = boostPFSConfig.custom.show_compare_at_price ? ' medium--right ' : '';
			var class2 = boostPFSConfig.custom.product_reviews_enable ? ' has-reviews' : '';
			var savePrice = data.compare_at_price_min - data.price_min;
            /* Start-Boost-231939 */
            if (typeof onSaleVariant[0] !== 'undefined') {
                savePrice = variantComparePrice - variantPrice;
            }
            /* End-Boost-231939 */
			savePrice = Utils.formatMoney(savePrice, Globals.moneyFormat, true);
			itemPriceHtml += '<span class="badge badge--sale"><span class="badge-label">';          
           	var final_price = Math.round(parseFloat(((data.compare_at_price_min - data.price_min) / data.compare_at_price_min) * 100)); 
            /* Start-Boost-231939 */
            if (typeof onSaleVariant[0] !== 'undefined') {
                final_price = Math.round(parseFloat(((variantComparePrice - variantPrice) / variantComparePrice) * 100));
            }
            /* End-Boost-231939 */
          	itemPriceHtml += boostPFSConfig.label.save_price.replace(/{{ saved_amount }}/g, '-' +final_price + '%&nbsp;OFF' );
 			itemPriceHtml += '</span></span>';
		} else {
          if(data.price_max > data.price_min){
            itemPriceHtml += ' - <small class="compare-price 13212"><span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
            itemPriceHtml += buildPriceHtml(data.price_max);
            itemPriceHtml += '</small>';
          }  
        }
        var itemPriceHtml_zero = '';
        if(data.price_min == 0){
          itemPriceHtml_zero += '<span class="product-price medium--left 123" style="opacity:0;"><span class="visually-hidden">Regular price</span><small aria-hidden="true"><lomoney>00.00</lomoney></small><span class="visually-hidden"><lomoney>00.00</lomoney></span></span>';
          itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml_zero);  
        } else {
    		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
        }
        
        /* Bundle Offer Tag */      
        var count_bundle_tag = false;
        var count_special_tag = false;
        $(data.tags).each(function( index, element ) {
          //console.log(element);
          if(element == 'Bundle Deal'){
            count_bundle_tag = true;
            var bundle_tag = '<span class="badge badge--bundle-offer"><span class="badge-label">BUNDLE DEAL</span></span>';
            itemHtml = itemHtml.replace(/{{itembundleofferLabel}}/g, bundle_tag);
          } else{
            itemHtml = itemHtml.replace(/{{itembundleofferLabel}}/g, '');
          }
          
          /* Special Price */
          if(element == 'special-price'){            
            count_special_tag = true;
            var special_tag = '<span class="badge badge-special-price"></span>';
            itemHtml = itemHtml.replace(/{{itemspecialLabel}}/g, special_tag);            
          }
          
        });
        itemHtml = itemHtml.replace(/{{itemspecialLabel}}/g, '');
      
		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			var itemReviewHtml = boostPFSConfig.custom.product_reviews_enable ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span><br>' : '';
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewHtml);
		}

		// Main & Focus Image
		var aspect_ratio = null;
		var itemImgHtml = '';

		// Main Image
		if (images.length > 0) {		
			aspect_ratio = images[0]['width'] / images[0]['height'];
			var max_width = width;
			var max_height = height;
			if (aspect_ratio < 1) {
				max_width = height * aspect_ratio;
				if (images[0]['height'] < height) {
					max_height = images[0]['height'];
					max_width = images[0]['width'];
				} else {
					max_height = height;
				}
			} else {
				max_height = width / aspect_ratio;
				if (images[0]['width'] < width) {
					max_height = images[0]['height'];
					max_width = images[0]['width'];
				} else {
					max_width = width;
				}
			}
			itemImgHtml +=  '<div class="lazyload__image-wrapper no-js" style="max-width:' + max_width + 'px">' +
								'<div>' +
									'<img class="no-js" loading="lazy" src="' + Utils.getFeaturedImage(images, '580x') + '" ' +										
										' "alt="{{itemTitle}}"' +
									'/>' +
								'</div>' +
							'</div>' +
							'<noscript>' +
								'<img src="' + Utils.getFeaturedImage(images, '580x') + '"' +
									'srcset="' + Utils.getFeaturedImage(images, '580x') + ' 1x, ' + Utils.getFeaturedImage(images, '580@2x') + ' 2x" ' +
									'alt="{{itemTitle}}" style="opacity:1;"' +
								'/>' +
							'</noscript>';
		} else {
			itemImgHtml +=  '<div>' +
								'<img src="' + boostPFSConfig.general.no_image_url + '"/>' +
							'</div>';
		}

		// Focus Image
		if (images.length > 1) {
			aspect_ratio = images[1]['width'] / images[1]['height'];
			var max_width = width;
			var max_height = height;
			if (aspect_ratio < 1) {
				max_width = height * aspect_ratio;
				if (images[1]['height'] < height) {
					max_height = images[1]['height'];
					max_width = images[1]['width'];
				} else {
					max_height = height;
				}
			} else {
				max_height = width / aspect_ratio;
				if (images[1]['width'] < width) {
					max_height = images[1]['height'];
					max_width = images[1]['width'];
				} else {
					max_width = width;
				}
			}
						
			itemImgHtml +=  '<div class="collection-focus-image" style="max-width:' + max_width + 'px" >' +								
								'<img loading="lazy" width="580" class="collection-focus-image__img" src="' + Utils.getFeaturedImage([ images[1] ], '580x') + '" ' +			
								' "alt="{{itemTitle}}"' +																	
								'/>' +								
							'</div>';			
		}

		// Insert image data, with focs image optional
		itemHtml = itemHtml.replace(/{{itemImg}}/g, itemImgHtml);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		var productTitle = data.title;

		
		if(data.metafields && data.metafields.length) {
			data.metafields.forEach((metafield) => {
				if(metafield.key == 'short_title' && metafield.value && metafield.value !== '') {
					productTitle = metafield.value;
				}
			});
		}		
		
		
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, productTitle);
		// itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));

        /* Min price Variants URL */
        var variants_price = data.price_min;
        var variants_id = '';        
        $(data.variants).each(function( index, element ) {        
          if(element.price == data.price_min){
            var variants_price = element.price;
            var variants_id = element.id;
            itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data) + '?variant=' + variants_id);    
          } else{
            itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
          }
        }); 

        var count_collection = false;
        $(data.collections).each(function( index, element ) {
            if(element.handle == 'colourtrend-paint' || element.handle == 'contemporary-collection' || element.handle == 'historic-collection' || element.handle == 'weather-collection' ){
              count_collection = true;
              var collection_btn = 'hide-button';
              itemHtml = itemHtml.replace(/{{itemcollectionbtn}}/g, collection_btn);
              
              var enquiry_btn = '<div class="boost-pfs-addtocart-wrapper"><a href="'+ Utils.buildProductItemUrlWithVariant(data) +'" class="boost-pfs-addtocart-btn enquiry-btn"><span class="boost-pfs-addtocart-btn-text">ENQUIRE NOW</span></span></a></a></div>';
              itemHtml = itemHtml.replace(/{{itemenquirybtn}}/g, enquiry_btn);
              
            } else {
              
              if(data.price_min == 0){
                count_collection = true;
                var collection_btn = 'hide-button';
                itemHtml = itemHtml.replace(/{{itemcollectionbtn}}/g, collection_btn);
                var enquiry_btn = '<div class="boost-pfs-addtocart-wrapper"><a href="'+ Utils.buildProductItemUrlWithVariant(data) +'" class="boost-pfs-addtocart-btn enquiry-btn"><span class="boost-pfs-addtocart-btn-text">ENQUIRE NOW</span></span></a></a></div>';
                itemHtml = itemHtml.replace(/{{itemenquirybtn}}/g, enquiry_btn);
              } else{
                //itemHtml = itemHtml.replace(/{{itemenquirybtn}}/g, '');
              }  
            }
        });
      
        if(count_collection == false ){
          itemHtml = itemHtml.replace(/{{itemcollectionbtn}}/g, '');
          itemHtml = itemHtml.replace(/{{itemenquirybtn}}/g, '');
        }

        if(!data.images[1]){
          var no_image = 'no-image';
          itemHtml = itemHtml.replace(/{{itemnoimage}}/g, no_image); 
        } else{
          itemHtml = itemHtml.replace(/{{itemnoimage}}/g, ''); 
        }
      
        return itemHtml;
	};

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add soldOut class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		// Add onSale class
		var onSaleClass = onSale ? boostPFSTemplate.onSaleClass : '';
		itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);

		// Add soldOut label
		var itemSoldOutLabelHtml = soldOut ? boostPFSTemplate.soldOutLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Price
		var itemPriceHtml = '<span class="medium--left">';
		if (onSale) {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price  + '</span>';
		} else {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
		}
		itemPriceHtml += buildPriceHtml(data.price_min);
		if (onSale && boostPFSConfig.custom.show_compare_at_price) {
			itemPriceHtml += ' <small><s><span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
			itemPriceHtml += buildPriceHtml(data.compare_at_price_min);
			itemPriceHtml += '</s></small>';
		}
		itemPriceHtml += '</span>';
		if (onSale && boostPFSConfig.custom.product_show_saved_amount) {
			var class1 = boostPFSConfig.custom.show_compare_at_price ? ' medium--right ' : '';
			var class2 = boostPFSConfig.custom.product_reviews_enable ? ' has-reviews' : '';
			var savePrice = data.compare_at_price_min - data.price_min;
			savePrice = Utils.formatMoney(savePrice, Globals.moneyFormat, true);
			itemPriceHtml += '<span class="sale-tag' + class1 + class2 + '">';
			itemPriceHtml += boostPFSConfig.label.save_price.replace(/{{ saved_amount }}/g, savePrice);
			itemPriceHtml += '</span>';
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Description
		var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
		itemDescription = (itemDescription.split(" ")).length > 40 ? itemDescription.split(" ").splice(0, 40).join(" ") + '...' : itemDescription.split(" ").splice(0, 40).join(" ");
		itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));

		return itemHtml;
	};

	function buildPriceHtml(price) {
		var customPrice = Utils.formatMoney(price);
		if (!(Globals.moneyFormat.indexOf('money') > -1 || Globals.moneyFormat.indexOf('.') > -1)) {
			if (boostPFSConfig.custom.superscript_decimals) {
				if (Globals.moneyFormat.indexOf('{{amount}}') !== -1 || Globals.moneyFormat.indexOf('{{ amount }}') !== -1) {
					customPrice = customPrice.replace('.', '<sup>') + '</sup>';
				} else if (Globals.moneyFormat.indexOf('{{amount_with_comma_separator}}') !== -1 || Globals.moneyFormat.indexOf('{{ amount_with_comma_separator }}') !== -1) {
					customPrice = customPrice.replace(',', '<sup>') + '</sup>';
				}
			}
		}
		var html = '<small aria-hidden="true">' + customPrice + '</small>';
		html += '<span class="visually-hidden">' + Utils.formatMoney(price) + '</span>';
		return html;
	}

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml :  boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = boostPFSTemplate.displayTypeHtml;
		itemHtml = itemHtml.replace(/{{gridUrl}}/g, Utils.buildToolbarLink('display', 'list', 'grid'));
		itemHtml = itemHtml.replace(/{{listUrl}}/g, Utils.buildToolbarLink('display', 'grid', 'list'));
		itemHtml = itemHtml.replace(/{{gridView}}/g, Labels.gridView);
		itemHtml = itemHtml.replace(/{{listView}}/g, Labels.listView);

		return itemHtml;
	};

	Breadcrumb.prototype.compileTemplate = function (colData) {
		if (!colData) colData = this.collectionData;
		var breadcrumbHtml = '';
		if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			breadcrumbHtml = boostPFSTemplate.breadcrumbHtml;
			var colInfo = colData.collection;
			var currentCollectionHtml = '';
			if (Array.isArray(boostPFSConfig.general.current_tags) && boostPFSConfig.general.current_tags.length > 0) {
				currentCollectionHtml += ' <a href="/collections/' + colInfo.handle + '">' + colInfo.title + '</a>';
				currentCollectionHtml += ' <span class="divider" aria-hidden="true">&rsaquo;</span>'
				currentCollectionHtml += ' <span>' + current_tags.join(' + ') + '</span>';
			} else {
				currentCollectionHtml += ' <span>' + colInfo.title + '</span>';
			}
			breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollection}}/g, currentCollectionHtml);
		}

		return breadcrumbHtml;
	}

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {};

	// Build Additional Elements
	Filter.prototype.afterRender = function (data) {
		if (!data) data = this.data;
      
		jQ(document).ready(function() {
			if (typeof theme !== 'undefined' && theme.hasOwnProperty('Sections')) {
				var sections = new theme.Sections();
				sections.register('collection-template', theme.Collection);
			}
		});

        // Define totalProduct based on the number of products returned
        var totalProduct = data.total_product + '<span>Products</span>';
        
        // Check if there's exactly one product and update totalProduct accordingly
        if (data.total_product == 1) {
            totalProduct = data.total_product + '<span>Products</span>';
        }
    
        // Update the HTML of the .boost-pfs-filter-total-product element with totalProduct
        jQ('.boost-pfs-filter-total-product').html(totalProduct);

		if (window.SPR) {
			SPR.initDomEls();
			SPR.loadBadges();
		}
	};
})();